import { exQue } from "@/utils/gql";
import { GET_PALABRAS_EMPRESA } from "@/apollo/queries";
import {
  armarTerminos,
  claveSegmentacion,
  TERMINOS_DEFECTO,
} from "@/utils/terminos";

// Términos de la empresa del usuario (utils/terminos.js). App.vue los carga en
// cada login (y al recargar con la sesión abierta) y los vuelve a los defaults
// al cerrar sesión. Mientras no llegan, o si la query falla, quedan los
// defaults: ningún texto depende de que esto responda.
//
// Los componentes los leen del mixin global de main.js; las acciones de otros
// módulos, con rootGetters["terminos/termino"]("SUCURSAL").
export default {
  namespaced: true,

  state: {
    // { GERENCIA: término, SUCURSAL: término, … }, congelado: se reemplaza
    // entero en cada cambio, y eso es lo que ven los computed
    porClave: TERMINOS_DEFECTO,
  },

  mutations: {
    SET_TERMINOS(state, lista) {
      state.porClave = armarTerminos(lista);
    },
    RESET(state) {
      state.porClave = TERMINOS_DEFECTO;
    },
  },

  actions: {
    // network-only: si el backend agrega o cambia las palabras de una empresa,
    // se ven al volver a entrar, sin depender del caché de Apollo.
    async cargar({ commit, rootGetters }) {
      const idEmpresa = rootGetters["loginModule/idEmpresa"];
      try {
        const lista = await exQue(GET_PALABRAS_EMPRESA, {}, true);
        // Si mientras tanto se cerró la sesión o entró otra empresa, esta
        // respuesta ya no corresponde
        if (rootGetters["loginModule/idEmpresa"] === idEmpresa) {
          commit("SET_TERMINOS", lista);
        }
      } catch (e) {
        // exQue ya lo deja en consola y, sin mensaje de error, no muestra
        // toast. Los textos siguen con los defaults.
      }
    },
  },

  getters: {
    // termino("SUCURSAL") → término; undefined si la clave no existe
    termino: (state) => (clave) => state.porClave[clave],
    // terminoPorId(2) → término de sucursal; undefined si el id no es una
    // segmentación (por ejemplo "Transversal", id 0, en AlertaPush)
    terminoPorId: (state) => (id) => state.porClave[claveSegmentacion(id)],
  },
};
